import { Component, computed, input, Signal } from '@angular/core';
import { AbstractControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { QuestionBase, TextboxQuestion } from '@nx-customer-apps/shared/utils';
import { MatFormField, MatLabel, MatHint, MatError } from '@angular/material/form-field';
import { NgClass } from '@angular/common';
import { MatInput } from '@angular/material/input';
import { NgxMaskDirective } from 'ngx-mask';
import { TranslatePipe } from '@ngx-translate/core';
import { FormFieldStylesPipe } from '../../pipes';
import { ComponentsModule, IsNilPipe } from '@nx-customer-apps/components';

@Component({
    selector: 'vp-textbox',
    templateUrl: './textbox.component.html',
    styleUrl: './textbox.component.scss',
    imports: [
        ReactiveFormsModule,
        MatFormField,
        NgClass,
        MatLabel,
        MatInput,
        NgxMaskDirective,
        MatHint,
        MatError,
        ComponentsModule,
        TranslatePipe,
        FormFieldStylesPipe,
        IsNilPipe
    ]
})
export class TextboxComponent {
    public form = input.required<FormGroup>();
    public question = input.required<TextboxQuestion>();
    public isSubQuestion: Signal<boolean> = computed(() => !!this.question().isSubQuestion);
    public hint: string | null;

    get control(): AbstractControl {
        return this.form().get((this.question() as QuestionBase<any>).key) as AbstractControl;
    }

    get isInvalid(): boolean {
        return this.control?.invalid && this.control?.touched;
    }

    get errorMessage(): string {
        const errorMessage = this.control?.errors?.['message'];
        return errorMessage || (this.question() as QuestionBase<any>).defaultErrorMessage;
    }

    public onInput(event: Event): void {
        this.validateOnInput((event as InputEvent).data);
    }

    public onBlur(): void {
        this.hint = null;
    }

    private validateOnInput(value: string | null): void {
        (this.question() as TextboxQuestion).hints.forEach(hint => {
            this.hint = hint(value);
        });
    }
}
